// NOTE - THIS IS A DUMMY GRID CREATED ONLY FOR DEMO PURPOSE. WILL REMOVE THAT AFTER DEMO ON 19TH AUG 2024 WILL BE COMPLETED
import React from 'react';

import { ColDef } from 'ag-grid-community';
import { AgGridReact } from 'ag-grid-react';

import CustomHeader from './CustomHeader';
import { TngGrid } from '../../../../../../components/common';
import {
  CustomTooltip,
  TextCellRenderer,
} from '../../../../../../components/TngFindSection/components/TngDataGrid/CustomComponents/CustomCellRender';
import MoreOptionHeader from '../../../../../../components/TngFindSection/components/TngDataGrid/CustomComponents/MoreOptionHeader';
import MoreOption from '../../../../../../components/TngFindSection/components/TngDataGrid/CustomComponents/MoreOptions';

const FinancialDummyGrid = () => {
  // row data to be rendered
  const rowData = [
    { invoiceNumber: 'INV01', invoiceDate: '24-08-10', status: 'Unpaid' },
    { invoiceNumber: 'INV02', invoiceDate: '24-08-14', status: 'Paid' },
  ];
  // column definitions
  const columnDef: ColDef[] = [
    {
      headerName: 'Invoice number',
      field: 'invoiceNumber',
      headerComponent: CustomHeader,
      tooltipField: 'invoiceNumber',
      tooltipComponent: CustomTooltip,
      cellRenderer: TextCellRenderer,
    },
    {
      headerName: 'Invoice Generation Date',
      field: 'invoiceDate',
      headerComponent: CustomHeader,
      tooltipField: 'invoiceDate',
      tooltipComponent: CustomTooltip,
      cellRenderer: TextCellRenderer,
    },
    {
      headerName: 'Status',
      field: 'status',
      headerComponent: CustomHeader,
      tooltipField: 'status',
      tooltipComponent: CustomTooltip,
      cellRenderer: TextCellRenderer,
    },
    {
      headerName: '',
      cellRenderer: MoreOption,
      headerComponent: MoreOptionHeader,
      cellRendererParams: {
        moreOptionNavigation: [{ label: 'View /Download Invoice', navigationTo: '#' }],
      },
      maxWidth: 64,
      sortable: false,
      resizable: false,
      cellAriaRole: 'more option',
    },
  ];

  // grid options for ag-grid
  const gridOptions = {
    defaultColDef: {
      suppressMovable: true, // Prevent all columns from being moved
      minWidth: 182, // Set the default width for all columns
      resizable: false, // Disable column resizing
      sortable: false, // Make all columns sortable
      flex: 1, // auto adjust column width accordingly
    },
    reactiveCustomComponents: true,
    headerHeight: 45, // column header height
  };
  const onGridReady = (params: any) => {
    params.api.sizeColumnsToFit();
  };

  const onFirstDataRendered = (params: any) => {
    params.api.sizeColumnsToFit();
  };

  return (
    <TngGrid className="order_detail_financial_grid_container">
      <TngGrid className="ag-theme-alpine ag_grid_container" data-testid="data_grid">
        <AgGridReact
          rowData={rowData}
          columnDefs={columnDef}
          gridOptions={gridOptions}
          suppressClickEdit={true}
          onGridReady={onGridReady}
          suppressRowHoverHighlight={true}
          getRowHeight={() => 70}
          onFirstDataRendered={onFirstDataRendered}
          tooltipShowDelay={0} // Show tooltip immediately
        />
      </TngGrid>
    </TngGrid>
  );
};

export default FinancialDummyGrid;
